import React, { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { actions } from 'features/users/redux';

import useIfInviteHidden from './useIfInviteHidden';

const useInvitePlayer = () => {
  const dispatch = useDispatch();
  const refCode = useSelector(s => s.users.refCode);

  const [state, setState] = useState({
    isOpen: false,
  });

  const handleToggleModal = () => {
    setState(ps => ({
      ...ps,
      isOpen: !ps.isOpen,
    }));
  };

  const isHidden = useIfInviteHidden();

  useEffect(() => {
    if (!isHidden) {
      dispatch(actions.getRefCode());
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isHidden]);

  return ({
    values: {
      isHidden,
      state,
      refCode,
      refLink: `https://strickbet.net/referral?refCode=${refCode}`,
    },
    handlers: {
      handleToggleModal,
    },
  });
};

export default useInvitePlayer;